import { render } from "./PageEditor.vue?vue&type=template&id=69a4fc07"
import script from "./PageEditor.vue?vue&type=script&lang=js"
export * from "./PageEditor.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/admin/PageEditor.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "69a4fc07"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('69a4fc07', __exports__)) {
    api.reload('69a4fc07', __exports__)
  }
  
  module.hot.accept("./PageEditor.vue?vue&type=template&id=69a4fc07", () => {
    api.rerender('69a4fc07', render)
  })

}


export default __exports__